import React from 'react';
import PropTypes from 'prop-types';
import Button from '@pattern-library/buttons';
const propTypes = {
  /**
   * The conent to display in the tooltip
   */
  content: PropTypes.string.isRequired,
  /**
   * Optional: The text to display in the button
   */
  buttonText: PropTypes.string,
  /**
   * The id of the tooltip to render
   */
  id: PropTypes.number.isRequired,
  /**
   * Optional: the element to display in the tooltip component
   */
  triggerElement: PropTypes.node
};
function Tooltip(_ref) {
  let {
    content,
    buttonText,
    id,
    triggerElement
  } = _ref;
  const TOOLTIP_CLASSNAME = 'asc-tooltip';
  return /*#__PURE__*/React.createElement("div", {
    className: "asc-tooltip-container"
  }, triggerElement && /*#__PURE__*/React.cloneElement(triggerElement, {
    'className': 'asc-tooltip-anchor',
    'aria-describedby': `${TOOLTIP_CLASSNAME}-${id}`
  }), buttonText && /*#__PURE__*/React.createElement(Button, {
    text: buttonText,
    className: "asc-tooltip-anchor",
    type: "button",
    customAttrs: {
      'aria-describedby': TOOLTIP_CLASSNAME + '-' + id
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: TOOLTIP_CLASSNAME + ' asc-tooltip--demo',
    id: TOOLTIP_CLASSNAME + '-' + id,
    role: "tooltip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "asc-tooltip-body"
  }, /*#__PURE__*/React.createElement("p", null, content)), /*#__PURE__*/React.createElement("div", {
    className: "arrow"
  })));
}
Tooltip.propTypes = propTypes;
export default Tooltip;